(function () {
  const HIDDEN_CLASS = 'dr-fc-arrow--hidden';

  function toPositiveNumber(value) {
    const parsed = Number(value);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
  }

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function initFeaturedCollectionSlider(sliderComponent) {
    if (!sliderComponent || sliderComponent.dataset.drFcArrowsReady === 'true') return;

    const sectionRoot = sliderComponent.closest('.dr-featured-collection');
    if (!sectionRoot) return;

    const prevButton = sliderComponent.querySelector('.slider-button--prev[name="previous"]');
    const nextButton = sliderComponent.querySelector('.slider-button--next[name="next"]');
    if (!prevButton || !nextButton) return;

    function getTotalPages() {
      const fromSlider = toPositiveNumber(sliderComponent.totalPages);
      if (fromSlider) return fromSlider;

      const visibleSlides = Array.from(sliderComponent.querySelectorAll('.slider__slide')).filter(
        (element) => element.clientWidth > 0
      ).length;
      return Math.max(visibleSlides, 1);
    }

    function getCurrentPage(totalPages) {
      const fromSlider = toPositiveNumber(sliderComponent.currentPage) || 1;
      return clamp(fromSlider, 1, totalPages);
    }

    function syncArrows() {
      const totalPages = getTotalPages();
      const currentPage = getCurrentPage(totalPages);

      const isFirst = totalPages <= 1 || prevButton.hasAttribute('disabled') || currentPage <= 1;
      const isLast = totalPages <= 1 || nextButton.hasAttribute('disabled') || currentPage >= totalPages;

      // RTL mapping:
      // prev button is the right arrow, hide it on first page
      // next button is the left arrow, hide it on last page
      prevButton.classList.toggle(HIDDEN_CLASS, isFirst);
      nextButton.classList.toggle(HIDDEN_CLASS, isLast);
      prevButton.setAttribute('aria-hidden', isFirst ? 'true' : 'false');
      nextButton.setAttribute('aria-hidden', isLast ? 'true' : 'false');
    }

    function queueSync() {
      window.requestAnimationFrame(syncArrows);
    }

    sliderComponent.addEventListener('slideChanged', queueSync);
    sliderComponent.slider?.addEventListener('scroll', queueSync, { passive: true });
    window.addEventListener('resize', queueSync);

    sliderComponent.dataset.drFcArrowsReady = 'true';
    queueSync();
  }

  function initAllFeaturedCollectionSliders() {
    document
      .querySelectorAll('.dr-featured-collection slider-component')
      .forEach((sliderComponent) => initFeaturedCollectionSlider(sliderComponent));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllFeaturedCollectionSliders);
  } else {
    initAllFeaturedCollectionSliders();
  }

  document.addEventListener('shopify:section:load', function (event) {
    event.target
      .querySelectorAll?.('.dr-featured-collection slider-component')
      .forEach((sliderComponent) => initFeaturedCollectionSlider(sliderComponent));
  });
})();
